import { render } from "./AppUpload.vue?vue&type=template&id=1f57b3b2&scoped=true"
import script from "./AppUpload.vue?vue&type=script&lang=js"
export * from "./AppUpload.vue?vue&type=script&lang=js"

import "./AppUpload.vue?vue&type=style&index=0&id=1f57b3b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f57b3b2"]])

export default __exports__